import Prestador from "../domain/Prestador"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class PrestadorServices {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async getPrestadores(idLetrado) {

    const prestadoresData = await this.apiService.fetchPrestador(idLetrado)

    const listadoPrestadores = prestadoresData && 
    prestadoresData.map((prestador) => new Prestador(
      prestador.intIdLetradoCiaPrestador,
      prestador.razonSocial,
      prestador.cuit
      ))

      return listadoPrestadores

  }
}

export default PrestadorServices
